module.exports = __webpack_public_path__ + "static/InsurgeLogoWhite-4358c8d30ada98c047a52ee7a9b27fa3.png";